import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import axios from "axios";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { base_url, getToken } from "../../config/config";

const renderObject = (obj, indent = 0) => (
  <Stack spacing={1} sx={{ width: "100%", pl: indent * 2 }}>
    {Object.entries(obj).map(([key, value]) => (
      <Box key={key} sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", textTransform: "capitalize" }}
        >
          {key.replace(/([A-Z])/g, " $1")}:
        </Typography>
        {value !== null && typeof value === "object" ? (
          // Nested object: recurse
          renderObject(value, indent + 1)
        ) : (
          <Typography variant="body2">
            {value !== null && value !== undefined ? String(value) : "—"}
          </Typography>
        )}
      </Box>
    ))}
  </Stack>
);

export default function AnrLogs({ projectId }) {
  const [logs, setLogs] = useState([]);
  console.log("component called with Project ID:", projectId);

  const fetchLogs = async () => {
    try {
      if (projectId) {
        const response = await axios.get(
          `${base_url}/v1/getProjectLogs/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );
        console.log("Response from server:", response);
        if (response.data.status === 1) {
          setLogs(response.data.data);
          console.log("Logs fetched successfully:", response.data.data);
        } else {
          console.error("Failed to fetch logs:", response.statusText);
        }
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  const renderDetails = (detailsString) => {
    try {
      const details = JSON.parse(detailsString);
      return renderObject(details);
    } catch {
      return <Typography variant="body2">Invalid details format</Typography>;
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [projectId]);

  return (
    <Box sx={{ flex: "1 1 300px" }}>
      <Typography variant="h6" gutterBottom>
        System Logs
      </Typography>
      <Paper elevation={2} sx={{ maxHeight: 1000, overflowY: "auto", p: 1 }}>
        {logs.length > 0 ? (
          <List disablePadding>
            {logs.map((log) => (
              <Accordion key={log._id} disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box>
                    <Typography variant="subtitle1">{log.message}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {new Date(log.createdAt).toLocaleString()}
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {renderDetails(log.logDetails)}
                </AccordionDetails>
                <Divider component="li" />
              </Accordion>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="textSecondary" sx={{ p: 2 }}>
            No logs available
          </Typography>
        )}
      </Paper>
    </Box>
  );
}
